import { h } from "vue";

export const cartIcon = () => {
  return h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-shopping-cart",
      width: "44",
      height: "44",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "#2c3e50",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    },
    [
      h("path", {
        d: "M0 0h24v24H0z",
        fill: "none",
      }),
      h("circle", {
        cx: "9",
        cy: "19",
        r: "2",
      }),
      h("circle", {
        cx: "17",
        cy: "19",
        r: "2",
      }),
      h("path", {
        d: "M17 17H9V3H5",
      }),
      h("path", {
        d: "M6 5h14l-1.5 9H8",
      }),
    ]
  );
};

export const usersIcon = () => {
  return h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-users",
      width: "44",
      height: "44",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "#2c3e50",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    },
    [
      h("path", {
        d: "M0 0h24v24H0z",
        fill: "none",
      }),
      h("circle", {
        cx: "9",
        cy: "7",
        r: "4",
      }),
      h("path", {
        d: "M17 11v-2a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v2",
      }),
      h("path", {
        d: "M5.5 21h13",
      }),
      h("path", {
        d: "M12 16h6",
      }),
      h("path", {
        d: "M8.5 16h-2",
      }),
    ]
  );
};

export const dollarIcon = () => {
  return h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-dollar-sign",
      width: "44",
      height: "44",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "#2c3e50",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    },
    [
      h("path", {
        d: "M0 0h24v24H0z",
        fill: "none",
      }),
      h("path", {
        d: "M12 3v18",
      }),
      h("path", {
        d: "M8 8h4c1.657 0 3 1.343 3 3s-1.343 3-3 3H8",
      }),
      h("path", {
        d: "M8 16h8",
      }),
    ]
  );
};

export const clockIcon = () => {
  return h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-clock",
      width: "44",
      height: "44",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "#2c3e50",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    },
    [
      h("path", {
        d: "M0 0h24v24H0z",
        fill: "none",
      }),
      h("circle", {
        cx: "12",
        cy: "12",
        r: "9",
      }),
      h("path", {
        d: "M12 7v5l3 3",
      }),
    ]
  );
};
